import React from "react";

import { formatNameFL } from "Utils/formatName";

import { Grid } from "Common/Grid";
import { Div, Li, Ul } from "Common/HTML";

import { useFetchBrokerForm } from "./brokerForm.hooks";

const FooterLink = (props) => <a className="text-muted" {...props} />;

export const BrokerFormFooter = ({ showSISupportLinks }) => {
  const { isLoading, data = {} } = useFetchBrokerForm();
  const brokerForm = data?.brokerForm || {};
  return (
    <div className="mb-[40px]">
      <Grid componentClass="footer">
        <Div p={4} mx="auto" className="flex flex-col items-center">
          {isLoading ? (
            " "
          ) : (
            <>
              <p className="text-muted">
                &copy; {new Date().getFullYear()} Insurance products sold by {formatNameFL(brokerForm)}.
              </p>
              <Ul className="flex flex-col sm:flex-row justify-center flex-wrap" pl={0}>
                <Li className="list-none">Contact {formatNameFL(brokerForm)} for support:</Li>
                {brokerForm.supportPhone && (
                  <Li className="list-none" pl={4}>
                    Phone: {brokerForm.supportPhone}
                  </Li>
                )}
                {brokerForm.supportEmail && (
                  <Li className="list-none" pl={4}>
                    Email: {brokerForm.supportEmail}
                  </Li>
                )}
              </Ul>
              {showSISupportLinks && (
                <Ul className="flex flex-col sm:flex-row justify-center flex-wrap" pl={0}>
                  <Li className="list-none">Benefits Administration support:</Li>
                  <Li className="list-none" pl={4}>
                    Email: benefitsadmin@simplyinsured.com
                  </Li>
                </Ul>
              )}
              <Ul className="flex flex-row justify-center" pl={0}>
                <Li className="list-none">
                  <FooterLink href="https://get.simplyinsured.com/terms-of-service">Terms of Use</FooterLink>
                </Li>
                <Li className="list-none" pl={4}>
                  <FooterLink href="https://get.simplyinsured.com/privacy-policy">Privacy Policy</FooterLink>
                </Li>
              </Ul>
            </>
          )}
        </Div>
      </Grid>
    </div>
  );
};
